import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Create from "./pages/Create";
import History from "./pages/History";
import Pricing from "./pages/Pricing";
import Inspiration from "./pages/Inspiration";
import Credits from "./pages/Credits";
import Settings from "./pages/Settings";
import Billing from "./pages/Billing";
import Payment from "./pages/Payment";
import Subscription from "./pages/Subscription";
import Legal from "./pages/Legal";
import Help from "./pages/Help";
import Features from "./pages/Features";
import Gallery from "./pages/Gallery";
import Api from "./pages/Api";
import Changelog from "./pages/Changelog";
import Documentation from "./pages/Documentation";
import Tutorials from "./pages/Tutorials";
import Blog from "./pages/Blog";
import Community from "./pages/Community";
import About from "./pages/About";
import Careers from "./pages/Careers";
import Press from "./pages/Press";
import Contact from "./pages/Contact";
import Partners from "./pages/Partners";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";
import RGPD from "./pages/RGPD";
import Referral from "./pages/Referral";
import PaymentSuccess from "./pages/PaymentSuccess";
import Remix from "./pages/Remix";
import AdStudio from "./pages/AdStudio";
import AdHistory from "./pages/AdHistory";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/create" element={<Create />} />
            <Route path="/history" element={<History />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/inspiration" element={<Inspiration />} />
            <Route path="/credits" element={<Credits />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/help" element={<Help />} />
            <Route path="/features" element={<Features />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/api" element={<Api />} />
            <Route path="/changelog" element={<Changelog />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/tutorials" element={<Tutorials />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/community" element={<Community />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/press" element={<Press />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/rgpd" element={<RGPD />} />
            <Route path="/referral" element={<Referral />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/remix" element={<Remix />} />
            <Route path="/ad-studio" element={<AdStudio />} />
            <Route path="/ad-history" element={<AdHistory />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
